/**
 * BE cắt danh sách HSNL của khách còn 3 bản ghi nhưng VẪN trả meta.total của cả nhóm
 * (docx 07.08 [91]). Nếu FE bỏ qua meta thì khách tưởng nhóm chỉ có 3 NCC và không biết có gì
 * thêm sau khi đăng nhập — nên tính số bị ẩn để hiện gợi ý.
 *
 * @param shown số HSNL đã tải về (KHÔNG phải số sau khi lọc client-side)
 * @param totalAvailable meta.total từ BE; undefined khi chưa có dữ liệu
 * @returns số HSNL bị ẩn, 0 nếu không phải khách / thiếu meta / không ẩn gì
 */
export const hiddenSupplierCount = (
  isGuest: boolean,
  shown: number,
  totalAvailable?: number
): number => {
  if (!isGuest) return 0;
  if (typeof totalAvailable !== 'number' || !Number.isFinite(totalAvailable)) return 0;
  return Math.max(0, Math.trunc(totalAvailable) - shown);
};

export default hiddenSupplierCount;
